export const Loader: React.FC = (): JSX.Element => (
  <span className="Loader"></span>
)